import Vue from 'vue';

/**
 * 1. 在调用的时候必须写v-
 * 2. 在使用的组件上或者div的位置必须是绝对的，在需要拖拽的最外层样式上加上 position: absolute;
 * 3. 在所需要的样式上使用 v-drag
 * 4. 激活之后的样式名为 v-drag-active 没有激活的样式名为 v-drag-inactive
 *
 * @author Zhou Xinchen
 * @type {DirectiveOptions}
 */
const drag = Vue.directive('drag', {
    // 指令绑定到元素上回立刻执行bind函数，只执行一次
    bind: function (el) {

    },
    //inserted表示一个元素，插入到DOM中会执行inserted函数，只触发一次
    inserted: function (el,_,vnode) {
        let wMax = document.documentElement.clientWidth - el.offsetWidth;
        let hMax = document.documentElement.clientHeight - el.offsetHeight;
        if ("ontouchstart" in window) { // 移动端
            el.ontouchstart = function (e) {
                let time1 = new Date().getTime();
                let x = e.touches[0].pageX - el.offsetLeft;
                let y = e.touches[0].pageY - el.offsetTop;
                // 抑制浏览器端默认拖拽行为，移动端是拖拽屏幕，pc端无
                // e.preventDefault(); 开启后点击 子集点击事件事件会无效
                document.ontouchmove = function (e) {
                    let align = el.align || 1;
                    let time2 = new Date().getTime();
                    if (time2 - time1 > 300) {
                        el.classList.remove('v-drag-inactive')
                        el.classList.add('v-drag-active')
                    }
                    let left = Math.fixed(e.touches[0].pageX - x ,align);
                    let top = Math.fixed(e.touches[0].pageY - y ,align);

                    if (left < 0) left = 0;
                    else if (left > wMax) left = wMax;

                    if (top < 0) top = 0;
                    else if (top > hMax) top = hMax;

                    el.style.left = left + 'px';
                    el.style.top = top + 'px';

                    _.value({left , top});
                }
                document.ontouchend = function () {
                    let time2 = new Date().getTime();
                    if (time2 - time1 > 300) {
                        el.classList.remove('v-drag-active')
                        el.classList.add('v-drag-inactive')
                    }

                    document.ontouchmove = document.ontouchend = null;
                }
            }
        } else { // pc端
            el.onmousedown = function (e) {
                let time1 = new Date().getTime();
                let x = e.pageX - el.offsetLeft;
                let y = e.pageY - el.offsetTop;
                document.onmousemove = function (e) {
                    let align = el.align || 1;
                    let time2 = new Date().getTime();
                    if (time2 - time1 > 300) {
                        el.classList.remove('v-drag-inactive')
                        el.classList.add('v-drag-active')
                    }
                    let left = Math.fixed(e.pageX - x , align);
                    let top = Math.fixed(e.pageY - y , align);
                    el.style.left = left + 'px';
                    el.style.top = top + 'px';

                    _.value({left , top});
                }
                document.onmouseup = function () {
                    let time2 = new Date().getTime();
                    if (time2 - time1 > 300) {
                        el.classList.remove('v-drag-active')
                        el.classList.add('v-drag-inactive')
                    }
                    document.onmousemove = document.onmouseup = null;
                }
            }
        }
    },
    updated: function (el) {
    }
})

/**
 * 全局 mixin：为所有 el-dialog 自动添加"按标题栏拖动"能力
 * 无需在业务代码的每个 <el-dialog> 上单独添加指令，import 本文件后即自动生效。
 */
Vue.mixin({
    mounted: function () {
        // 仅处理 Element UI 的 Dialog 组件
        if (!this.$options || this.$options.name !== 'ElDialog') return;

        var headerEl = this.$el.querySelector('.el-dialog__header');
        var dragDom = this.$el.querySelector('.el-dialog');
        if (!headerEl || !dragDom) return;

        // 标题栏鼠标样式
        headerEl.style.cursor = 'move';

        headerEl.onmousedown = function (downEvent) {
            // 鼠标按下点相对标题栏的偏移
            var disX = downEvent.clientX - headerEl.offsetLeft;
            var disY = downEvent.clientY - headerEl.offsetTop;

            // 读取弹框当前定位，兼容 % 与 px
            var sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
            var styL, styT;
            if (sty.left.indexOf('%') !== -1) {
                styL = +document.body.clientWidth * (+sty.left.replace(/%/g, '') / 100);
                styT = +document.body.clientHeight * (+sty.top.replace(/%/g, '') / 100);
            } else {
                styL = +sty.left.replace(/px/g, '') || 0;
                styT = +sty.top.replace(/px/g, '') || 0;
            }

            document.onmousemove = function (moveEvent) {
                var l = moveEvent.clientX - disX;
                var t = moveEvent.clientY - disY;
                dragDom.style.left = (l + styL) + 'px';
                dragDom.style.top = (t + styT) + 'px';
            };

            document.onmouseup = function () {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        };
    }
});

export default drag;